// extracted by css-extract-rspack-plugin
export default {"TopBar":"Jwj3i","databaseSelector":"DY73Z"};